import React, { useEffect, useState } from 'react'
import InputField from './ui/InputField'
import TextAreaField from './ui/TextAreaField';
import FormButton from './ui/FormButton';
import { useNavigate, useParams } from 'react-router-dom';
import OutlinedButton from './ui/OutlinedButton';
import { getChallengeById } from '../services/api/challenges/getChallenge';
import { updateChallenge } from '../services/api/challenges/updateChallenge';

const EditChallengeForm = () => {
  const [challenge, setChallenge] = useState({ title:"",description:"",duration:60 });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    // console.log(params.challengeId);
    setIsLoading(true);
    getChallengeById(params.challengeId).then(response => {
        // console.log(response);
        if (response.error === null) {
            setChallenge({ title:response.data.title, description:response.data.description,duration:response.data.duration });
            setIsLoading(false);
        }
    });
  },[params.challengeId]);

  const handleChange = (e) => {
    const { name,value } = e.target;
    setChallenge(prev => ({...prev,[name]: value}));
  };

  const handleClear = () => {
    setChallenge({ title:"" , description:"", duration:60 });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (challenge.title.trim().length !== 0 && challenge.description.trim().length !== 0 && challenge.duration.trim().length !== 0) {
      setIsLoading(true);
      updateChallenge(params.challengeId,challenge.title,challenge.description,challenge.duration).then(response => {
        if (!(response.error === null)) {
          alert('an error');
        }else{
          alert('challenge updated');
        }
      }).finally(() => {
        setIsLoading(false);
        handleCancel();
      });
    }else{
      alert('fill all the details');
    }
  };

  const handleCancel = () => { handleClear(); navigate(-1);}; 
 
  return (
    <div className='flex justify-center'>
    {challenge.title.length === 0?'Loading...':<form method='POST' className='flex flex-col gap-4 min-w-full sm:min-w-[650px] sm:max-w-[650px]' onSubmit={handleSubmit}>
        <p className='text-lg font-semibold text-blue-500 text-center'>Update Challenge</p>
    <InputField
        label="Challenge Title"
        name="title"
        value={challenge.title}
        onChange={handleChange}
        required={true}
        placeholder="Enter a challenge title"
      />
        <TextAreaField
        label="Challenge Description"
        name="description"
        value={challenge.description}
        onChange={handleChange}
        placeholder="Enter a detailed description of challenge"
        rows={6}  
        required={true}
      />
      <InputField
        label="Challenge Duration(in minutes)"
        name="duration"
        type='number'
        value={challenge.duration}
        onChange={handleChange}
        required={true}
        placeholder="Enter a challenge duration"
      />
       <div className='flex items-center gap-2 justify-end'>
    <OutlinedButton label={'cancel'} onClick={handleCancel} />
    <FormButton
        label={isLoading ? 'Updating...' : 'Update Challenge'}
        type={'submit'}
        disabled={isLoading}
      />
        </div>
    </form>}
    </div>
  )
}

export default EditChallengeForm